/* Page-local progressive enhancement. No dependencies, storage or cart calls. */
if (!customElements.get('qq-keyboard-guide')) {
  customElements.define('qq-keyboard-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.panels = [...this.querySelectorAll('[data-part-panel]')];
      this.picks = [...this.querySelectorAll('[data-part-pick]')];
      this.lines = [...this.querySelectorAll('[data-part-line]')];
      if (!this.panels.length) return;
      this.classList.add('is-ready');
      this.selectPart(this.panels[0].dataset.partPanel);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-part-pick]');
        if (button && this.contains(button)) this.selectPart(button.dataset.partPick);
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const id = event.detail?.blockId;
        if (this.panels.some(panel => panel.dataset.partPanel === id)) this.selectPart(id);
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, { signal });
    }
    selectPart(id) {
      this.panels.forEach(panel => { panel.hidden = panel.dataset.partPanel !== id; });
      this.picks.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.partPick === id)));
      this.lines.forEach(line => line.classList.toggle('is-active', line.dataset.partLine === id));
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
